/**
 * Re 1 Sale — daily countdown (1:00 PM–2:00 PM IST, then until next 1:00 PM IST).
 */
(function () {
  const TZ = 'Asia/Kolkata';
  const SALE_START_HOUR = 13;
  const SALE_END_HOUR = 14;

  const MS_SECOND = 1000;
  const MS_MINUTE = MS_SECOND * 60;
  const MS_HOUR = MS_MINUTE * 60;
  const MS_DAY = MS_HOUR * 24;

  function pad(value) {
    return value < 10 ? `0${value}` : String(value);
  }

  function getISTParts(date) {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    const parts = Object.fromEntries(
      formatter.formatToParts(date).map((part) => [part.type, part.value])
    );

    let hour = Number(parts.hour);
    if (hour === 24) hour = 0;

    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour,
      minute: Number(parts.minute),
      second: Number(parts.second),
    };
  }

  function istToMs(year, month, day, hour, minute = 0, second = 0) {
    return new Date(
      `${year}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}+05:30`
    ).getTime();
  }

  function addCalendarDays(year, month, day, days) {
    return getISTParts(new Date(istToMs(year, month, day, 12) + days * MS_DAY));
  }

  function getSaleState(now) {
    const { year, month, day } = getISTParts(now);
    const nowMs = now.getTime();
    const startMs = istToMs(year, month, day, SALE_START_HOUR);
    const endMs = istToMs(year, month, day, SALE_END_HOUR);

    /*

  // TEST ONLY — remove or set false before production
  const TEST_SALE = true;
  const TEST_START_DELAY_MS = 1 * MS_MINUTE;   // live starts 5 min after refresh
  const TEST_LIVE_DURATION_MS = 60 * MS_MINUTE; // live lasts 1 hour (use 5 * MS_MINUTE for a short test)
  if (TEST_SALE) {
    const bootMs = window.__re1SaleTestBootMs || (window.__re1SaleTestBootMs = Date.now());
    const startMs = bootMs + TEST_START_DELAY_MS;
    const endMs = startMs + TEST_LIVE_DURATION_MS;
    const nowMs = now.getTime();
    if (nowMs >= startMs && nowMs < endMs) {
      return { phase: 'live', targetMs: endMs };
    }
    if (nowMs < startMs) {
      return { phase: 'upcoming', targetMs: startMs };
    }
    return { phase: 'upcoming', targetMs: startMs + MS_DAY };
  }

*/






    if (nowMs >= startMs && nowMs < endMs) {
      return { phase: 'live', targetMs: endMs };
    }

    if (nowMs < startMs) {
      return { phase: 'upcoming', targetMs: startMs };
    }

    const tomorrow = addCalendarDays(year, month, day, 1);
    return {
      phase: 'upcoming',
      targetMs: istToMs(tomorrow.year, tomorrow.month, tomorrow.day, SALE_START_HOUR),
    };
  }

  function splitCountdown(differenceMs) {
    if (differenceMs <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(differenceMs / MS_DAY),
      hours: Math.floor((differenceMs / MS_HOUR) % 24),
      minutes: Math.floor((differenceMs / MS_MINUTE) % 60),
      seconds: Math.floor((differenceMs / MS_SECOND) % 60),
    };
  }

  /** Live sale window: hours + minutes + seconds (days hidden in markup) */
  function splitCountdownLive(differenceMs) {
    if (differenceMs <= 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      hours: Math.floor(differenceMs / MS_HOUR),
      minutes: Math.floor((differenceMs / MS_MINUTE) % 60),
      seconds: Math.floor((differenceMs / MS_SECOND) % 60),
    };
  }

  function initSaleTimer(root) {
    if (root.dataset.timerInitialized === 'true') return;
    root.dataset.timerInitialized = 'true';

    const labelEl = root.querySelector('[data-timer-label]');
    const badgeEl = root.querySelector('[data-timer-badge]');
    const reminderBtn = root.querySelector('[data-timer-reminder]');
    const daysEls = root.querySelectorAll('[data-timer-days]');
    const hoursEls = root.querySelectorAll('[data-timer-hours]');
    const minutesEls = root.querySelectorAll('[data-timer-minutes]');
    const secondsEls = root.querySelectorAll('[data-timer-seconds]');

    const labelLive = root.dataset.labelLive || 'SALE LIVE NOW';
    const labelUpcoming = root.dataset.labelUpcoming || 'Next Sale Goes Live In';

    function render() {
      const { phase, targetMs } = getSaleState(new Date());
      const remainingMs = Math.max(0, targetMs - Date.now());
      const parts = phase === 'live' ? splitCountdownLive(remainingMs) : splitCountdown(remainingMs);

      root.dataset.state = phase;

      if (labelEl) {
        labelEl.textContent = phase === 'live' ? labelLive : labelUpcoming;
      }

      if (badgeEl) {
        badgeEl.textContent = labelLive;
      }

      if (reminderBtn) {
        reminderBtn.hidden = phase === 'live';
      }

      if (phase === 'live') {
        const formatted = {
          hours: pad(parts.hours),
          minutes: pad(parts.minutes),
          seconds: pad(parts.seconds),
        };

        hoursEls.forEach((el) => {
          el.textContent = formatted.hours;
        });
        minutesEls.forEach((el) => {
          el.textContent = formatted.minutes;
        });
        secondsEls.forEach((el) => {
          el.textContent = formatted.seconds;
        });
        return;
      }

      const formatted = {
        days: pad(parts.days),
        hours: pad(parts.hours),
        minutes: pad(parts.minutes),
        seconds: pad(parts.seconds),
      };

      daysEls.forEach((el) => {
        el.textContent = formatted.days;
      });
      hoursEls.forEach((el) => {
        el.textContent = formatted.hours;
      });
      minutesEls.forEach((el) => {
        el.textContent = formatted.minutes;
      });
      secondsEls.forEach((el) => {
        el.textContent = formatted.seconds;
      });
    }

    render();
    window.setInterval(render, 1000);
  }

  function initReminderButtons() {
    document.querySelectorAll('[data-timer-reminder]:not([data-reminder-bound])').forEach((button) => {
      button.dataset.reminderBound = 'true';
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-reminder-target');
        const form = targetId ? document.getElementById(targetId) : null;

        if (!form) return;

        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = form.querySelector('input, textarea, select, button');
        if (focusable) focusable.focus({ preventScroll: true });
      });
    });
  }

  function boot(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-re-1-sale-timer]').forEach(initSaleTimer);
    initReminderButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });

  window.Re1SaleTimer = {
    getSaleState,
    TZ,
    SALE_START_HOUR,
    SALE_END_HOUR,
  };
})();
